module.exports = __webpack_public_path__ + "img/microplastics-process-2-mobile.bc343c71.png";